import { ReactElement } from 'react'

import IActiveOrInactiveImpl from 'modules/veiculos/domain/usecases/ActiveOrInactive'
import GetImagemVeiculoImpl from 'modules/veiculos/domain/usecases/GetImagemVeiculo'

import DeleteVeiculoImpl from '../../domain/usecases/DeleteVeiculo'
import ListVeiculos from '../../domain/usecases/ListVeiculosImpl'
import VeiculoRespository from '../../infra/repositories/VeiculosRepository'
import List from '../../pages/List'

export const ListFactory = (): ReactElement => {
  const veiculoRespository = new VeiculoRespository()
  const listVeiculos = new ListVeiculos(veiculoRespository)
  const activeOrInactive = new IActiveOrInactiveImpl(veiculoRespository)
  const deleteVeiculo = new DeleteVeiculoImpl(veiculoRespository)
  const getImagemVeiculo = new GetImagemVeiculoImpl(veiculoRespository)

  return (
    <List
      findVeiculos={listVeiculos}
      activeOrInactive={activeOrInactive}
      deleteVeiculo={deleteVeiculo}
      getImagemVeiculo={getImagemVeiculo}
    />
  )
}
